import React, { useMemo, useState } from 'react';
import { AgCharts } from 'ag-charts-react';
import { formatBigNumbersToString, formatValueAsString } from '../../../../../../utils/helpers';
import { AgChartOptions } from 'ag-charts-community';

interface IMainEngineFuelTypeChartProps {
	trueSum: number;
	falseSum: number;
	title: string;
}

const VesselEtsFuelEuEmissionsChart: React.FC<IMainEngineFuelTypeChartProps> = ({ ...props }) => {
	const formatOptions = useMemo(() => ({ minimumFractionDigits: 0, maximumFractionDigits: 2 }), []);

	const [options] = useState<AgChartOptions>({
		data: [
			{
				type: 'Emissions',
				TrueSum: props.trueSum !== 0 ? props.trueSum : undefined,
				FalseSum: props.falseSum !== 0 ? props.falseSum : undefined,
			},
		],
		title: {
			text: props.title,
			textAlign: 'left',
			fontSize: 14,
			spacing: 15,
		},
		series: [
			{
				type: 'bar',
				direction: 'horizontal',
				xKey: 'type',
				yKey: 'FalseSum',
				yName: 'non-Qualifying',
				stacked: true,
				fill: '#183D57',
				label: {
					enabled: true,
					color: '#FFFFFF',
					fontWeight: 'bold',
					formatter: ({ value }: { value: number }) => `${formatValueAsString(value, formatOptions, '', '', '')}`,
				},
				tooltip: {
					renderer(params) {
						return {
							data: undefined,
							title: 'non-Qualifying',
							heading: formatValueAsString(params.datum['FalseSum'], formatOptions, '', '', ''),
						};
					},
				},
			},
			{
				type: 'bar',
				direction: 'horizontal',
				xKey: 'type',
				yKey: 'TrueSum',
				yName: 'Qualifying',
				stacked: true,
				fill: '#F0D035',
				label: {
					enabled: true,
					color: '#FFFFFF',
					fontWeight: 'bold',
					formatter: ({ value }: { value: number }) => `${formatValueAsString(value, formatOptions, '', '', '')}`,
				},
				tooltip: {
					renderer(params) {
						return {
							data: undefined,
							title: 'Qualifying',
							heading: formatValueAsString(params.datum['TrueSum'], formatOptions, '', '', ''),
						};
					},
				},
			},
		],
		legend: {
			position: 'bottom',
			spacing: 15,
			item: {
				// label: {
				// 	fontSize: 10,
				// },
				marker: {
					shape: 'circle',
					size: 10,
				},
			},
		},
		axes: [
			{
				type: 'category',
				position: 'left',
				label: {
					enabled: false,
					rotation: -90, // Rotate labels 90 degrees counter-clockwise
				},
			},
			{
				type: 'number',
				position: 'bottom',
				label: {
					formatter: ({ value }: { value: number }) => {
						return formatBigNumbersToString(value);
					},
				},
				nice: false,
			},
		],
		padding: { top: 0, bottom: 0, left: 5, right: 10 },
	});

	return <AgCharts options={options} className="w-full h-full" style={{ height: '140px' }} />;
};

export default VesselEtsFuelEuEmissionsChart;
